/* Audit Assistant — clickable suggestion chips. Clicking a chip sends it.
   Used twice: the welcome screen (the 8 starter prompts) and under an
   assistant answer (that answer's follow-up questions). */
import type { JSX } from 'react';
import { SUGGESTION_PROMPTS } from '../../mock/mockResponses';

interface SuggestionChipsProps {
  onPick: (prompt: string) => void;
  disabled?: boolean;
  /** Defaults to the welcome-screen starter prompts. */
  prompts?: string[];
  /** Optional heading above the chips (e.g. "Follow-up questions"). */
  label?: string;
}

export function SuggestionChips({
  onPick,
  disabled,
  prompts = SUGGESTION_PROMPTS,
  label,
}: SuggestionChipsProps): JSX.Element {
  const ariaLabel = label ?? 'Suggested questions';
  return (
    <div className="aa-suggest">
      {label && <div className="aa-suggest-label">{label}</div>}
      <div className="aa-chips" role="list" aria-label={ariaLabel}>
        {prompts.map((p) => (
          <button
            key={p}
            type="button"
            role="listitem"
            className="aa-chip"
            disabled={disabled}
            onClick={() => onPick(p)}
          >
            {p}
          </button>
        ))}
      </div>
    </div>
  );
}
